import React from 'react';
import Tooltip from 'material-ui/Tooltip';
import Place from 'material-ui-icons/Place';
import { assets } from '../../assets/';
import { enums } from '../../enums/';

export class AssetProducingMarker extends React.Component {
  goToAsset(assetId) {
    this.props.history.push('/assets/prod/read/' + assetId);
  }

  render() {
    const producingAsset = this.props.producingAsset;
    let assetIcon;

    switch (producingAsset.assetType) {
      case enums.AssetType.WIND_TURBINE:
        assetIcon = assets.images.windTurbineMapIcon2;
        break;
      case enums.AssetType.SOLAR_PANEL:
        assetIcon = assets.images.solarPanelMapIcon2;
        break;
      case enums.AssetType.DAM:
        assetIcon = assets.images.damMapIcon2;
        break;
      case enums.AssetType.FACTORY:
        assetIcon = assets.images.factoryMapIcon2;
        break;
      case enums.AssetType.GEOTHERMAL:
        assetIcon = assets.images.geothermalIcon;
        break;
      case enums.AssetType.SOLID_BIOMASS:
        assetIcon = assets.images.solidBiomassIcon;
        break;
      default:
        assetIcon = assets.icons.boltMapIcon2;
    }

    let tooltipContent = producingAsset.displayedName;
    tooltipContent += producingAsset.houseNumber
      ? ` | ${producingAsset.houseNumber} ${producingAsset.street}`
      : producingAsset.street;
    tooltipContent += ` | ${parseInt(
      producingAsset.capacityWh / 1000000,
      10
    )}  MW`;

    return (
      <div key={'producingAsset-' + producingAsset.id}>
        <Tooltip title={tooltipContent}>
          <div
            onClick={() => {
              this.goToAsset(producingAsset.id);
            }}
          >
            <Place
              style={{
                color: '#F87733',
                fontSize: 52,
                position: 'absolute',
                top: -40,
                left: -21,
              }}
            />
            <img
              src={assetIcon}
              alt="asset"
              style={{
                maxHeight: 19,
                marginLeft: 19,
                marginRight: 19,
                marginBottom: -4,
                position: 'absolute',
                top: -30,
                left: -23,
              }}
            />
          </div>
        </Tooltip>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MapCards/AssetProducingMarker.js